import {Spinner} from 'quickstart/components/layout/Spinner'
import {MetaDigest} from 'quickstart/components/tizra/MetaDigest'
import {logger, meta} from 'tizra'
import type {BrowseGalleryProps} from '..'
import {useInfiniteBrowse} from './useInfiniteBrowse'

const log = logger('BrowseGallery/digests')

export const DigestsGallery = ({
  background,
  foreground,
  linkColor,
  maxItems,
  search,
  search: {isFetching, results},
  slots,
}: BrowseGalleryProps) => {
  const {bottomRef, items} = useInfiniteBrowse({maxItems, search})

  return (
    <div style={{position: 'relative'}}>
      <MetaDigest.Group
        background={background}
        foreground={foreground}
        linkColor={linkColor}
      >
        {items?.map((r, i) => (
          <MetaDigest
            key={meta.key(r)}
            metaObj={r}
            slots={slots}
            ref={i === items.length - 1 ? bottomRef : undefined}
          />
        ))}
      </MetaDigest.Group>
      {!isFetching ?
        null
      : results ?
        <div style={{height: '2rem'}}>
          <Spinner dim={false} />
        </div>
      : <Spinner />}
    </div>
  )
}
